const statsSection = document.querySelector('.stats')
const statsContainer = document.querySelectorAll('.gsap-stats')
const statsGlobe = document.querySelector('.stats-globe-container')

if (statsSection && statsContainer.length > 0) {
	gsap.registerPlugin(ScrollTrigger)

	// Hide stats section initially
	gsap.set(statsSection, { display: "none" })

	// Set globe initial state if it exists
	if (statsGlobe) {
		gsap.set(statsGlobe, { autoAlpha: 0, y: 200, xPercent: -50 })
	}

	statsContainer.forEach((statContainer, index) => {
		const statEl = statContainer.querySelector('.h1')
		const statSubheading = statContainer.querySelector('h4')
		const number = statEl.textContent.trim()

		// Wrap the number in a span for pseudo-element brackets
		const numberSpan = document.createElement('span')
		numberSpan.className = 'stat-number'
		numberSpan.textContent = number

		// Clear original content and add number span
		statEl.textContent = ''
		statEl.appendChild(numberSpan)

		// Temporarily show the span to measure its width
		gsap.set(numberSpan, {
			autoAlpha: 1,
			width: "auto",
			display: "block"
		})

		// Get the actual width of the number span
		const numberWidth = numberSpan.offsetWidth

		// Set initial state - brackets visible, number hidden
		gsap.set(numberSpan, {
			autoAlpha: 0,
			width: 0,
			display: "block",
			"--bracket-opacity": 1,
			"--bracket-left-x": "0px",
			"--bracket-right-x": "0px"
		})
		gsap.set(statSubheading, {
			autoAlpha: 0,
			display: "inline-block"
		})

		// Calculate bracket positions based on number width
		const bracketOffset = numberWidth / 5
		const staggerDelay = index * 0.3

		// Create animation timeline for this stat with scroll trigger
		const tl = gsap.timeline({
			paused: true,
			delay: staggerDelay
		})

		tl.to(numberSpan, {
			duration: 0.6,
			"--bracket-left-x": `-${bracketOffset}px`,
			"--bracket-right-x": `${bracketOffset}px`,
			ease: "power2.out"
		})
		.to(numberSpan, {
			duration: 0.4,
			autoAlpha: 1,
			width: "auto",
			ease: "power2.out"
		}, "-=0.1")
		.to(numberSpan, {
			duration: 0.5,
			"--bracket-opacity": 0,
			ease: "power2.in"
		}, "-=0.1")
		.to(statSubheading, {
			duration: 0.3,
			autoAlpha: 1,
			ease: "power2.out"
		}, "-=0.1")

		// Create scroll trigger to control animation
		ScrollTrigger.create({
			trigger: statsSection,
			start: "top bottom",
			onEnter: () => {
				// Show stats section when animation starts
				gsap.set(statsSection, { display: "grid" })
				// Animate globe only once (on first stat's trigger)
				if (index === 0 && statsGlobe) {
					gsap.to(statsGlobe, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out' })
				}
				// Restart timeline with delay to maintain stagger
				tl.restart(true)
			},
			onLeaveBack: () => {
				tl.progress(0).pause()
				gsap.set(statsSection, { display: "none" })
				// Reset globe only once (on first stat's trigger)
				if (index === 0 && statsGlobe) {
					gsap.set(statsGlobe, { autoAlpha: 0, y: 200, xPercent: -50 })
				}
			}
		})
	})
}
